import { render, staticRenderFns } from "./Brain.vue?vue&type=template&id=14879782&scoped=true&"
import script from "./Brain.vue?vue&type=script&lang=js&"
export * from "./Brain.vue?vue&type=script&lang=js&"
import style0 from "./Brain.vue?vue&type=style&index=0&id=14879782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14879782",
  null
  
)

export default component.exports